import { render, staticRenderFns } from "./view5.vue?vue&type=template&id=72aa0eea&scoped=true&"
import script from "./view5.vue?vue&type=script&lang=js&"
export * from "./view5.vue?vue&type=script&lang=js&"
import style0 from "./view5.vue?vue&type=style&index=0&id=72aa0eea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa0eea",
  null
  
)

export default component.exports